export default "assets/images/logo-veynat-4d1c0f3b.png";